module.exports = __webpack_public_path__ + "static/img/promotional_2.7ab657a5.jpg";